import React from "react";
import Logo4 from "../../../assets/images/png/partner-logo/Binance-logo.png";
import Logo5 from "../../../assets/images/png/partner-logo/Halcyon-Logo-Stacked-BlackCyan.png";
import JCILogo from "../../../assets/images/png/partner-logo/JCI.png";
import Logo6 from "../../../assets/images/png/partner-logo/act_foundation.png";
import Logo3 from "../../../assets/images/png/partner-logo/facebook.webp";
import HPLogo from "../../../assets/images/png/partner-logo/hp.png";
import Logo from "../../../assets/images/png/partner-logo/jica.webp";
import Logo2 from "../../../assets/images/png/partner-logo/mits.webp";
import Logo7 from "../../../assets/images/png/partner-logo/ms_logo.webp";

const Card = ({ title, logo, description, linkUrl }) => {
  return (
    <div className="relative lg:mb-6 h-full">
      <div
        className={`partner-card relative rounded-xl px-6 lg:px-12 py-8 lg:py-10 h-full flex flex-col `}
      >
        <div className="h-24 object-contain">
          <img src={logo} alt="" className="w-24 h-24 object-contain" />
        </div>
        <div className="mt-6 lg:mt-8">
          <h2 className="text-lg font-medium">{title}</h2>
          <p className="mt-4 pb-5 text-sm md:text-sm-15 lg:text-base text-default">
            {description?.length > 200
              ? description?.slice(0, 200) + "..."
              : description}
          </p>

          <div className="mt-2 ">
            {linkUrl && (
              <a
                href={linkUrl}
                target={"_blank"}
                rel="noopener noreferrer"
                className="font-semibold text-primary text-sm lg:text-sm-15"
              >
                Read more
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const PartnersListingSection = () => {
  const data = [
    {
      id: 7,
      logo: Logo7,
      title: "MICROSOFT",
      linkUrl:
        "https://pt-br.facebook.com/utiva.io/videos/more-opportunities-to-for-our-learnerstoday-were-super-excited-to-announce-our-p/822526335061720/?__so__=permalink&__rv__=related_videos#:~:text=Today%2C%20we're%20super%20excited,in%20over%2080%20other%20countries.",
      description: `
      Utiva partners with Microsoft to give our cloud 
      computing learners discount offers so that they can earn the 
      global certification
              `,
    },
    {
      id: 8,
      logo: HPLogo,
      title: "HP Foundation",
      linkUrl:
        "https://techeconomy.ng/2021/08/tech-skills-utiva-in-50000-partnership-with-hp-to-train-equip-5000-women-and-girls/",
      description: `
      HP Foundation funds and backs Utiva with $50,000 to 
      train women and girls in Kenya with premium technology skills. 
                `,
    },
    {
      id: 1,
      logo: Logo,
      title: "JICA",
      linkUrl:
        "https://www.jica.go.jp/nigeria/english/office/topics/gh13tc000000sz4y-att/220328_01.pdf",
      description: `
      JICA funds and partners with Utiva to scale our training to more than 15 new cities in Africa and reach 10,000 people
            `,
    },
    {
      id: 6,
      logo: Logo6,
      title: "Act Foundation",
      linkUrl: "https://m.facebook.com/watch/?v=904026800536659&_rdr",
      description: `
      Act Foundation provided an impact grant to Utiva to deliver training to more 
      than 5000 young people and funded the launch of new programs like Programming, Cloud Computing and 
      Product Marketing
                    `,
    },
    {
      id: 2,
      logo: Logo2,
      title: "MIT Solve",
      linkUrl:
        "https://solve.mit.edu/challenges/good-jobs-and-inclusive-entrepreneurship/solutions/20415",
      description: `
      MIT Solve provided funding to Utiva to build a new technology product this product was used 
      to help the government of Nigeria deliver training to rural communities
              `,
    },
    {
      id: 3,
      logo: Logo3,
      title: "Facebook Accelerator",
      linkUrl:
        "https://www.facebook.com/community/2020communitydirectory/SSA/#eyitayo-ogunmola",
      description: `
      Facebook, through the Facebook Accelerator program selected Utiva as one of the 
      largest learning community in Africa and provided funding to grow
                `,
    },
    {
      id: 4,
      logo: Logo4,
      title: "Binance Africa",
      linkUrl:
        "https://www.binance.com/en-NG/blog/all/binance-to-host-blockchain-education-bootcamp-for-women-in-collaboration-with-utiva-421499824684903545",
      description: `
      Binance Africa worked with Utiva to train more than 
      300 women and girls in Blockchain technology and tech skills virtually through coaching and mentoring!  
                  `,
    },
    {
      id: 7,
      logo: Logo4,
      title: "Binance Charity",
      linkUrl:
        "https://flipboard.com/article/binance-charity-partners-with-utiva-to-educate-50-000-youths-and-provide-tech-tr/f-8503848e12%2Fnairametrics.com",
      description: `
        Binance Charity funds Utiva to scale digital skill training and provide mentorship to 50,000 people in Africa.  
                    `,
    },
    {
      id: 5,
      logo: Logo5,
      title: "Halcyon Incubator",
      linkUrl: "https://www.halcyonhouse.org/venture/utiva/",
      description: `
      Halcyon Incubator selected Utiva in 2020. Through this partnership and 
      incubation relationship, Utiva built its new set of virtual training 
      programs and worked with Deloitte...
                  `,
    },
    {
      id: 6,
      logo: JCILogo,
      title: "JCI Nigeria",
      //   linkUrl: "https://www.halcyonhouse.org/venture/utiva/",
      description: `
      Utiva partnered with JCI to train over 500 young people in awareness 
      program in Nigeria and then extended the partnership to provide funding to 50 young people to learn tech...
                    `,
    },
  ];
  return (
    <section className="pt-16 lg:pt-4 pb-16 relative">
      <div className="container px-4 mx-auto pb-16">
        <div className="w-full lg:w-11/12 mx-auto">
          <div className="relative grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-x-4 lg:gap-x-8 gap-y-6 lg:gap-y-14 mt-16">
            {data?.map((datum, index) => (
              <Card
                key={index}
                logo={datum?.logo}
                description={datum?.description}
                linkUrl={datum?.linkUrl}
                title={datum?.title}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PartnersListingSection;
